import type { EventContentArg } from '@fullcalendar/core';
import { Box, IconButton, styled } from '@mui/material';
import { blue } from 'common/theme/palette/colors';
import { shadows } from 'common/theme/shadows';

export const StyledEventContent = styled(Box, {
  name: 'CalendarItem',
  shouldForwardProp: (prop) => prop === 'children',
})<EventContentArg>(({ theme: { palette }, isPast }) => ({
  '.fc-v-event:has(&)': {
    ...(isPast && {
      backgroundColor: palette.grey[300],
      borderColor: palette.grey[300],
    }),

    '& .MuiButtonBase-root': {
      display: 'none',
    },

    '&:hover': {
      boxShadow: shadows['light-shadow-8'],
      ...(!isPast && {
        '--fc-event-bg-color': blue[600],
        '--fc-event-border-color': blue[600],
      }),

      '& .MuiButtonBase-root': {
        display: 'flex',
      },
    },
  },
}));

export const RemoveButton = styled(IconButton)({
  position: 'absolute',
  top: 5,
  right: 4,
  color: 'inherit',
});

RemoveButton.defaultProps = {
  size: 'xs',
};
